import React, { useEffect, useState, useContext } from "react";
import SellerSidebar from "../../../navigation/sellerNavigation";
import UserCard from "../../../props/userCard";
import {getData} from "../../../fetchRoutes/getData";
import { patchDataRaw } from "../../../fetchRoutes/patchDataRaw";
import { deleteData } from "../../../fetchRoutes/deleteData";
import SellerMobileSidebar from "../../../navigation/sellerMobileNavigation";
import { DeviceContext } from "../../../context/deviceContext";

export default function UserContainer() {


    const getAllUsersUrl = process.env.REACT_APP_GET_ALL_USERS;

    const deleteUserUrl = process.env.REACT_APP_DELETE_USER;

    const updateRoleUrl = process.env.REACT_APP_UPDATE_ROLE;

    const {isMobile}= useContext(DeviceContext);
    

    const [users, setUsers] = useState([]);
    const [error, setError]= useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(()=>{

        async function fetchUsers(){
            try{
                const response = await getData(getAllUsersUrl);

                if(response.status === 'Success'){
                    setUsers(response.data);
                }

            }catch(error){
                setError('Something went wrong!');

            }finally{
                setIsLoading(false);
                setError('');
            }
        }

        fetchUsers();
    // eslint-disable-next-line
    },[]);


    // Handle Delete
    const handleDelete = (id) => {
        async function deleteUser (){
            setIsLoading(true);
            
            try{
                const url = `${deleteUserUrl}/${id}`;

                const response = await deleteData(url);

                if(response.status === 'Success'){
                    setIsLoading(false);

                    setUsers((prevUsers) => prevUsers.filter((user) => user._id !== id));

                }

            }catch(error){
                setError('Something went wrong');

            }finally{
                setIsLoading(false);
                setError('');

            }
        }
        
        deleteUser();
    };


    // Handle role update
    const handleUpdateRole = (id, selectedRole) => {

        async function updateUserRole (){
            setIsLoading(true);

            try{
                const url = `${updateRoleUrl}/${id}`;


                const response = await patchDataRaw(url, {role:selectedRole});
                console.log(response);

                if (response.status === 'Success') {
                    // Update the local state with the updated role
                    const updatedUser = response.data.user;
            
                    setUsers((prevUsers) =>
                        prevUsers.map((user) =>
                        user._id === id ? { ...user, role: updatedUser.role } : user
                        )
                    );
                }
            }catch(error){
                setError('Something went wrong try again!');

            }finally{
                setIsLoading(false);
                setError('');

            }
        }

        updateUserRole();
    };

    // Handle pagination
    const [currentPage, setCurrentPage] = useState(1);
    const usersPerPage = isMobile ? 2 : 8; 
    const totalPages = Math.ceil(users.length / usersPerPage);

    const indexOfLastUser = currentPage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    const currentUsers = users.slice(indexOfFirstUser, indexOfLastUser);

    return (
        <main className="sellerDashboard">
            {isMobile ? <SellerMobileSidebar/> :<SellerSidebar />}

            {isLoading && (
                <div className="loaderContainer">
                    <div className="loader"></div>
                    <p className="loadingText">Loading...</p>
                </div>
            )}

            {error && <p className="errorMessage">{error}</p>}

            <div className={`container ${currentUsers.length <=4 && 'moreProperties'} `}>
                <h1 className="containerTitle">USERS</h1>
                <div className="propertyList">
                    {currentUsers.map((user) => (
                        <UserCard
                            key={user._id}
                            user={user}
                            onDelete={handleDelete}
                            onUpdateRole={handleUpdateRole}
                        />
                    ))}
                </div>

                {totalPages > 1 && (
                    <div className="pagination">
                        <button
                            onClick={() => setCurrentPage((prev) => prev - 1)}
                            disabled={currentPage === 1}
                            className={`btnPagination ${currentPage === 1 ? 'disabled' : ''}`}
                        >
                            Previous
                        </button>
                        <span className="pageInfo">
                            Page {currentPage} of {totalPages}
                        </span>
                        <button
                            onClick={() => setCurrentPage((prev) => prev + 1)}
                            disabled={currentPage === totalPages}
                            className={`btnPagination ${currentPage === totalPages ? 'disabled' : ''}`}
                        >
                            Next
                        </button>
                    </div>
                )}
            </div>
        </main>
    );
}
